import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { ImageStyleProps } from '../contentful-elements/Image';
import LazyLoadStyle from './LazyLoadStyle';
import PropsComponent from './types/PropsComponent';

type SectionProps = {
  backgroundColor?: string;
  backgroundLinear?: string;
  darkOverlay?: boolean;
};

const Section = styled.section`
  background: ${({ darkOverlay }: SectionProps) => darkOverlay && 'rgba(0, 0, 0, 0.25);'};
  background-color: ${({ backgroundColor }: SectionProps) => backgroundColor};
  background-image: ${({ backgroundLinear }: SectionProps) => backgroundLinear};
  background-size: cover;
  position: relative;
  width: 100%;
`;

export const BackgroundImageStyles = css`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  top: 0;
  left: 0;
  object-fit: cover;
`;

type Props = {
  id?: string;
  Image?: PropsComponent<ImageStyleProps>;
  backgroundColor?: string;
  backgroundLinear?: string;
  children?: ReactNode;
  darkOverlay?: boolean;
};

const Headliner = ({
  id,
  Image,
  backgroundColor,
  backgroundLinear,
  children,
  darkOverlay = false,
}: Props) => {
  return (
    <Section
      id={id}
      backgroundColor={backgroundColor}
      backgroundLinear={backgroundLinear}
      darkOverlay={darkOverlay}
    >
      {Image && (
        <LazyLoadStyle>
          <Image css={BackgroundImageStyles} aspectRatios={{ mobile: 9 / 16, tablet: 16 / 9 }} />
        </LazyLoadStyle>
      )}
      {children}
    </Section>
  );
};

export default Headliner;
